import getResetPasswordStore from "../../../../stores/supervisor-store/reset-password-store";
import Et3Button from "../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";

const ResetPasswordForm = withLiteObserverAndTheme(() => {
  return (
    <Et3Button
      isEnabled={true}
      onClick={async () => {
        await getResetPasswordStore().getActiveAdmins();
      }}
      size="LARGE"
      type="GET"
      text="GET"
    />
  );
});
export default ResetPasswordForm;
